import { ILandingPoint } from '../../interfaces/ilanding-point';
import { Area } from '../area';
import { TargetFormation } from '../target-formation';

export class LandingPointBase {
  LandingPointId: number;
  AreaId: number;
  TargetFormationId: number;
  LandingPointTVD: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  TargetFormation?: TargetFormation;

  constructor(item?: ILandingPoint) {
    if (item) {

      this.LandingPointId = item.LandingPointId;
      this.AreaId = item.AreaId;
      this.TargetFormationId = item.TargetFormationId;
      this.LandingPointTVD = item.LandingPointTVD;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
    }
  }
}